/* DistriPañales: comportamiento «tab attention» desactivado.
   El tema original cambiaba document.title al perder el foco ("We're still here!" / "Come back for rewards!").
   Ahora el título de la pestaña nunca se reemplaza y se conserva siempre el del sitio. */
if (!window.Eurus.loadedScript.has('tab-attention.js')) {
  window.Eurus.loadedScript.add('tab-attention.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xTabAttention', () => ({
        init() {},
      }));
    });
  });
}
